export default __webpack_public_path__ + "locales/el-GR/FillPDFDialog.json?hash=caaae0fd9beb60d9ea150aa438316e86";